export const ACCESS_TOKEN_KEY = "accToken";
export const SUB_ID = "subId";
export const ASSO_SUBS = "assoSubs";
export const REFRESH_TOKEN_KEY = "refToken";
export const ID_TOKEN_KEY = "idToken";
export const IS_SSO_LOGIN_KEY = "isSSOLogin";
export const HASURA_CLAIMS_KEY = "https://hasura.io/jwt/claims";
